// extracted by mini-css-extract-plugin
export default {"crashDetail":"IssueCrashPreview__crashDetail__Ct48M","crashDetailHeader":"IssueCrashPreview__crashDetailHeader__Dlcwj","IconHover":"IssueCrashPreview__IconHover__GpjZB"};